import React from 'react'
import { Link } from 'react-router-dom'

import useScrollAnimation from '../hooks/useScrollAnimation'
import './mission.css'

const Mission = (props) => {
  const [ref, isVisible] = useScrollAnimation()

  return (
    <section ref={ref} className={`mission-section ${isVisible ? 'animate-in' : ''}`}>
      <div className="mission-inner">
        <div className="mission-label">Philosophy</div>
        <h2 className="mission-statement">
          My work lies at the intersection of
          <span className="mission-highlight"> design</span>,
          <span className="mission-highlight"> data</span>, and
          <span className="mission-highlight"> systems</span> —
          where I develop tools and strategies that enable more resilient,
          efficient, and intelligent ways to plan, analyze, and deliver
          sustainable infrastructure.
        </h2>
        <div className="mission-actions">
          <Link to="/projects" className="mission-cta-primary">
            View my projects
            <svg width="16" height="16" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round">
              <path d="M5 12h14M12 5l7 7-7 7" />
            </svg>
          </Link>
          <Link to="/about" className="mission-cta-secondary">
            More about me
          </Link>
        </div>
      </div>
    </section>
  )
}

export default Mission
